import React from 'react'
import _map from 'lodash/map'
import _groupBy from 'lodash/groupBy'
import _sortBy from 'lodash/sortBy'
import _keys from 'lodash/keys'
import _isEmpty from 'lodash/isEmpty'
import moment from 'moment'
import { Chart } from '../../_library/Chart'
import EmptyBar from '../../_library/EmptyBar'
import SortableTable from '../../_library/SortableTable'
import { getTableColumns } from '../../utils/sortableTableUtils'
import { DAY_DISPLAY_FORMAT, DAY_FORMAT, TIME_FORMAT_SHORT } from '../../constants/timeFormats'

export default class CheckInHourly extends React.Component {
  constructor(props) {
    super(props)
    this.tableColumns = getTableColumns([
      {
        key: 'dateTime',
        label: 'Time',
        disableNormalizerOnCopy: true,
        normalizer: value => (
          <span>
            <span className="text-large">{moment(value, 'YYYY-MM-DD HH').format(TIME_FORMAT_SHORT)}</span> /
            {` ${moment(value, 'YYYY-MM-DD HH').format(DAY_DISPLAY_FORMAT)}`}
          </span>
        ),
      },
      { key: 'quantityComponent', label: 'No. of Tickets' },
    ])
    this.footbarColumns = [{ key: 'quantityComponent', component: null }]

    this.state = {
      tableData: [],
      totalSold: 0,
    }
  }

  componentDidMount() {
    this.getTableData()
  }

  componentDidUpdate(prevProps) {
    const { performance, data } = this.props
    if (performance !== prevProps.performance || data !== prevProps.data) {
      this.getTableData()
    }
  }

  getTotalComponent = (dataForDate, totalSold) => {
    const totalCheckedIn = _map(dataForDate, item => item.quantity).reduce((sum, val) => sum + val, 0)
    const remaining = totalSold - totalCheckedIn

    return (
      <span>
        {`${totalCheckedIn} / `}
        <strong>{totalSold}</strong>
        {` (${remaining} remaining)`}
      </span>
    )
  }

  getTableData = () => {
    const { data, performance = [] } = this.props

    // Calculate total tickets sold from performance data
    let totalSold = 0
    _map(performance, row => {
      totalSold += !isNaN(parseInt(row.num_sales)) ? parseInt(row.num_sales) : 0
    })

    const dataArray = _map(_keys(data), item => ({
      dateTime: item,
      date: moment(item, 'YYYY-MM-DD HH').format(DAY_FORMAT),
      time: moment(item, 'YYYY-MM-DD HH').format(TIME_FORMAT_SHORT),
      quantity: data[item],
      quantityComponent: <span>{data[item]}</span>,
    }))

    const sortedData = _sortBy(dataArray, ['date'])
    const dataGroupedByDate = _groupBy(sortedData, item => item.date)

    this.setState({
      tableData: dataGroupedByDate,
      totalSold,
    })
  }

  render() {
    const { tableData, totalSold } = this.state

    return (
      <div style={{ margin: 10 }}>
        <div className="daily-title">
          Check-Ins by <strong>HOUR</strong>
        </div>
        {_isEmpty(tableData) ? (
          <EmptyBar />
        ) : (
          <div>
            {(() => {
              let cumulativeTotal = 0
              const sortedDates = _keys(tableData).sort()

              return _map(sortedDates, key => {
                const dataItem = tableData[key]
                const dateTotal = _map(dataItem, item => item.quantity).reduce((sum, val) => sum + val, 0)
                cumulativeTotal += dateTotal

                const footbarColumns = [{
                  key: 'quantityComponent',
                  component: (
                    <span>
                      {`${cumulativeTotal} / `}
                      <strong>{totalSold}</strong>
                      {` (${totalSold - cumulativeTotal} remaining)`}
                    </span>
                  )
                }]

                return (
                <div key={key} style={{ marginBottom: 30 }}>
                  <div className="row">
                    <div className="col-xs-12">
                      <Chart
                        width={'100%'}
                        height="300px"
                        chartConfig={{
                          type: 'bar',
                          data: {
                            labels: _map(dataItem, item => item.time),
                            datasets: [
                              {
                                data: _map(dataItem, item => item.quantity),
                              },
                            ],
                          },
                          options: {
                            legend: {
                              display: false,
                            },
                          },
                        }}
                      />
                    </div>
                  </div>
                  <br />
                  <div className="table-caption">
                    <img alt="no-data" src={asset('/resources/images/icon-timer.png')} className="icon" />
                    {moment(key).format(DAY_DISPLAY_FORMAT)}
                  </div>
                  <SortableTable
                    data={dataItem}
                    dataForCopy={_map(dataItem, item => ({ dateTime: item.time, quantity: item.quantity }))}
                    tableColumns={this.tableColumns}
                    enableCopyTable={true}
                    enableSort={true}
                    footbar={{
                      label: 'Total:',
                      columns: footbarColumns,
                    }}
                  />
                </div>
              )
            })
          })()}
          </div>
        )}
      </div>
    )
  }
}
